import { useEditor, useValue } from "tldraw"
import { LDPage } from "../../shared/LDPage"

export function useCurrentPage() {
  const editor = useEditor()

  const currentPage = useValue(
    'currentPage',
    () => editor.getCurrentPage() as LDPage,
    [editor]
  )

  return currentPage
}
